import { PermissionEnum } from './permission'

export const PagePermission = {
  ADMIN_ARTICLE_LIST: [PermissionEnum.ADMIN_ARTICLE_LIST],
  ADMIN_ARTICLE_CREATE: [PermissionEnum.ADMIN_ARTICLE_CREATE],
  ADMIN_ARTICLE_UPDATE: [PermissionEnum.ADMIN_ARTICLE_UPDATE, PermissionEnum.ADMIN_ARTICLE_SHOW],
  ADMIN_ARTICLE_DETAIL: [PermissionEnum.ADMIN_ARTICLE_SHOW],
  ADMIN_ARTICLE_LANGUAGE_CREATE: [PermissionEnum.ADMIN_ARTICLE_LANGUAGE_CREATE],
  ADMIN_ARTICLE_LANGUAGE_UPDATE: [
    PermissionEnum.ADMIN_ARTICLE_LANGUAGE_SHOW,
    PermissionEnum.ADMIN_ARTICLE_LANGUAGE_UPDATE,
  ],

  ADMIN_CATEGORY_LIST: [PermissionEnum.ADMIN_CATEGORY_LIST],
  ADMIN_CATEGORY_CREATE: [PermissionEnum.ADMIN_CATEGORY_CREATE],
  ADMIN_CATEGORY_DETAIL: [PermissionEnum.ADMIN_CATEGORY_SHOW],

  ADMIN_DOCTOR_LIST: [PermissionEnum.ADMIN_DOCTOR_LIST],
  ADMIN_DOCTOR_CREATE: [PermissionEnum.ADMIN_DOCTOR_CREATE],
  ADMIN_DOCTOR_UPDATE: [PermissionEnum.ADMIN_DOCTOR_UPDATE],
  ADMIN_DOCTOR_DETAIL: [PermissionEnum.ADMIN_DOCTOR_SHOW],

  ADMIN_LOCATION_LIST: [PermissionEnum.ADMIN_LOCATION_LIST],
  ADMIN_LOCATION_CREATE: [PermissionEnum.ADMIN_LOCATION_CREATE],
  ADMIN_LOCATION_DETAIL: [PermissionEnum.ADMIN_LOCATION_SHOW],
  ADMIN_LOCATION_UPDATE: [PermissionEnum.ADMIN_LOCATION_UPDATE],
  ADMIN_LOCATION_IMAGE_DETAIL: [PermissionEnum.ADMIN_LOCATION_IMAGE_SHOW],
  ADMIN_LOCATION_REVIEW_DETAIL: [PermissionEnum.ADMIN_LOCATION_REVIEW_SHOW],

  ADMIN_MAIN_PAGE_VIDEO_LIST: [PermissionEnum.ADMIN_MAIN_PAGE_VIDEO_LIST],
  ADMIN_MAIN_PAGE_VIDEO_CREATE: [PermissionEnum.ADMIN_MAIN_PAGE_VIDEO_CREATE],
  ADMIN_MAIN_PAGE_VIDEO_DETAIL: [PermissionEnum.ADMIN_MAIN_PAGE_VIDEO_SHOW],
  ADMIN_MAIN_PAGE_VIDEO_UPDATE: [PermissionEnum.ADMIN_MAIN_PAGE_VIDEO_UPDATE],

  ADMIN_LOCATION_LABEL_LIST: [PermissionEnum.ADMIN_LOCATION_LABEL_LIST],
  ADMIN_LOCATION_LABEL_CREATE: [PermissionEnum.ADMIN_LOCATION_LABEL_CREATE],
  ADMIN_LOCATION_LABEL_DETAIL: [PermissionEnum.ADMIN_LOCATION_LABEL_SHOW],

  ADMIN_LOCATION_GROUP_LIST: [PermissionEnum.ADMIN_LOCATION_GROUP_LIST],
  ADMIN_LOCATION_GROUP_CREATE: [PermissionEnum.ADMIN_LOCATION_GROUP_CREATE],
  ADMIN_LOCATION_GROUP_DETAIL: [PermissionEnum.ADMIN_LOCATION_GROUP_SHOW],

  ADMIN_LOCATION_SERVICE_LIST: [PermissionEnum.ADMIN_LOCATION_SERVICE_LIST],
  ADMIN_LOCATION_SERVICE_CREATE: [PermissionEnum.ADMIN_LOCATION_SERVICE_CREATE],
  ADMIN_LOCATION_SERVICE_DETAIL: [PermissionEnum.ADMIN_LOCATION_SERVICE_SHOW],

  ADMIN_MAIN_PAGE_DOCTOR_LIST: [PermissionEnum.ADMIN_MAIN_PAGE_DOCTOR_FETCH],

  ADMIN_OUR_DOCTOR_PAGE_DOCTOR_LIST: [PermissionEnum.ADMIN_OUR_DOCTOR_PAGE_DOCTOR_FETCH],

  ADMIN_BANNER_LIST: [PermissionEnum.ADMIN_BANNER_LIST],
  ADMIN_BANNER_CREATE: [PermissionEnum.ADMIN_BANNER_CREATE],
  ADMIN_BANNER_UPDATE: [PermissionEnum.ADMIN_BANNER_UPDATE],

  ADMIN_PROMOTION_LIST: [PermissionEnum.ADMIN_PROMOTION_LIST],
  ADMIN_PROMOTION_CREATE: [PermissionEnum.ADMIN_PROMOTION_CREATE],
  ADMIN_PROMOTION_UPDATE: [PermissionEnum.ADMIN_PROMOTION_SHOW, PermissionEnum.ADMIN_PROMOTION_UPDATE],
  ADMIN_PROMOTION_DETAIL: [PermissionEnum.ADMIN_PROMOTION_SHOW],
  ADMIN_PROMOTION_LANGUAGE_CREATE: [PermissionEnum.ADMIN_PROMOTION_LANGUAGE_CREATE],
  ADMIN_PROMOTION_LANGUAGE_UPDATE: [
    PermissionEnum.ADMIN_PROMOTION_LANGUAGE_SHOW,
    PermissionEnum.ADMIN_PROMOTION_LANGUAGE_UPDATE,
  ],

  ADMIN_MAIN_PAGE_LOCATION_GROUP_LIST: [PermissionEnum.ADMIN_MAIN_PAGE_LOCATION_GROUP_FETCH],
}
